import React from "react";
import PropTypes from "prop-types";
import { MAP, MARKER } from "react-google-maps/lib/constants";

class Spiderfy extends React.Component {
    static contextTypes = {
        [MAP]: PropTypes.object
    };

    constructor(props, context) {
        super(props, context);
        const oms = require(`npm-overlapping-marker-spiderfier/lib/oms.min`)
        this.oms = new oms.OverlappingMarkerSpiderfier(this.context[MAP], {
            markersWontMove: true,   // we promise not to move any markers, allowing optimizations
            markersWontHide: true,   // we promise not to change visibility of any markers, allowing optimizations
            basicFormatEvents: true  // allow the library to skip calculating advanced formatting information});
        });
        this.markerNodeMounted = this.markerNodeMounted.bind(this);
    }

    markerNodeMounted(ref) {
        if (ref) {
            const marker = ref.state[MARKER];
            this.oms.addMarker(marker);
            window.google.maps.event.addListener(marker, "spider_click", (e) => {
                if (this.props.onSpiderClick) this.props.onSpiderClick(ref._reactInternalFiber.index)
            });
        }
    }

    render() {
        return React.Children.map(this.props.children, child =>
            React.cloneElement(child, { ref: this.markerNodeMounted })
        );
    }
}

export default Spiderfy;
